import request from "@/utils/request";

const url = "/api/textmarkers";

const getTextMarkers = ({ bookId }) => {
  return request.get(`${url}?book_id=${bookId}`);
};
const saveTextMarkers = (body) => {

  const formData = new FormData();
  for (let key in body) {
    formData.append(key, body[key]);
  }

  return request
    .post(url, {
      body: formData,
      token: true
    });
};
const removeTextMarkers = ({ textMarkerId }) => {
  return request
    .delete(`/api/textmarkers/${ textMarkerId }`, {
      token: true
    });
};

export default {
  saveTextMarkers,
  getTextMarkers,
  removeTextMarkers
};
